import * as React from 'react';
export const invoiceSvg = React.forwardRef(function invoiceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.5 3.7a.7.7 0 0 1 .7-.7h2.1a.7.7 0 1 1 0 1.4H4.2a.7.7 0 0 1-.7-.7ZM4.2 6a.7.7 0 1 0 0 1.4h3.6a.7.7 0 1 0 0-1.4H4.2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.804 11.434a.5.5 0 0 0 .381-.027l1.762-.88a.25.25 0 0 1 .112-.027H10a1 1 0 0 0 1-1V2a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v9a1 1 0 0 0 1 1h1.382a.5.5 0 0 0 .224-.053l1.801-.9a.25.25 0 0 1 .191-.014l1.206.402ZM4.78 9.794a1.65 1.65 0 0 1 1.26-.09l.852.284 1.428-.714a1.65 1.65 0 0 1 .74-.174h.54V2a.6.6 0 0 0-.6-.6H3a.6.6 0 0 0-.6.6v8.6h.77l1.611-.806Z',
    }),
  );
});
invoiceSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var invoice = {
  category: 'icon',
  colorable: true,
  name: 'invoice',
  svg: invoiceSvg,
};
